module.exports = "<svg style=\"height: 256px; width: 256px;\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"><path d=\"M0 0h512v512H0z\" fill=\"transparent\" fill-opacity=\"0\"></path><g class style=\"touch-action: none;\" transform=\"translate(0,0)\"><path d=\"M480.25 156.355c0 161.24-224.25 324.43-224.25 324.43S31.75 317.595 31.75 156.355c0-91.41 70.63-125.13 107.77-125.13 77.65 0 116.48 65.72 116.48 65.72s38.83-65.73 116.48-65.73c37.14.01 107.77 33.72 107.77 125.14z\" fill=\"currentColor\" fill-opacity=\"1\"></path></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/heart.svg
// module id = QVSs
// module chunks = 1